import AuthClient from '@skyscanner/auth-client';
import GoogleOneTapGC from '@skyscanner-internal/global-components/google-one-tap';
import {
  loadGSIScriptPropFn,
  SubscriptionClient,
} from '@skyscanner-internal/global-components/google-one-tap/helpers';
import logger from 'saddlebag-logger';

import { useShouldRenderGoogleOneTap } from '../../utils/loginPromptEvents';
import withErrorBoundary from '../ErrorBoundary';

import type { GoogleOneTapServerSideProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/GoogleOneTap';

const GoogleOneTap = ({
  enableLoginFormAutoPromptSEO,
  ...props
}: GoogleOneTapServerSideProps) => {
  const shouldRender = useShouldRenderGoogleOneTap({
    enableLoginFormAutoPromptSEO,
    market: props.market,
  });

  if (!shouldRender) return null;

  const authClient = new AuthClient({
    locale: props.locale,
    market: props.market,
    authConsumer: 'google-yolo-seo',
    env: props.isProductionEnv ? 'production' : 'development',
  });
  const subscriptionClient = new SubscriptionClient();
  return (
    <GoogleOneTapGC
      {...props}
      authClient={authClient}
      loadGSIScriptPropFn={loadGSIScriptPropFn}
      logger={logger}
      subscriptionClient={subscriptionClient}
    />
  );
};

const GoogleOneTapWithErrorBoundary = withErrorBoundary(
  GoogleOneTap,
  'GoogleOneTap',
);

export default GoogleOneTapWithErrorBoundary;
